import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uploadFileType } from '../../enum';
import Org from '@/components/organization';
export default {
  components: {
    Org: Org
  },
  props: {
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      orgVisible: false,
      // 文件上传类型
      uploadFileType: uploadFileType
    };
  },
  computed: {
    selectedOrg: function selectedOrg(vm) {
      return vm.form.default.departmentList.map(function (item) {
        return {
          department_id: item.id,
          department_name: item.name
        };
      });
    }
  },
  methods: {
    // 打开部门弹窗
    handleOpenOrg: function handleOpenOrg() {
      this.orgVisible = true;
    },
    // 部门选择
    handleSelectPerson: function handleSelectPerson(params) {
      var dept_list = params.dept_list;
      this.form.default.departmentList = dept_list.map(function (item) {
        return {
          id: item.department_id,
          name: item.department_name
        };
      });
      this.handleChangePerson();
    },
    // 删除选中部门
    handleDelDepartment: function handleDelDepartment(index) {
      this.form.default.departmentList.splice(index, 1);
    },
    // 根据单选或多选决定默认值
    handleChangePerson: function handleChangePerson() {
      var _this = this;
      var _this$form = this.form,
        optionalQuantity = _this$form.optionalQuantity,
        departmentList = _this$form.default.departmentList;
      this.$nextTick(function () {
        if (optionalQuantity === 'single' && departmentList.length) {
          _this.form.default.departmentList = [departmentList[0]];
          _this.$message({
            message: _this.$t('i18n.cce08545944e4877906283951b4270b8'),
            type: 'warning'
          });
        }
      });
    }
  }
};